/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useMemo } from 'react';
import { getStartedPropertyResource } from '@jira/router-resources__service-desk-customer-service-get-started-property/src/getStartedPropertyResource.tsx';
import { isJCSProjectType } from '@jira/servicedesk__customer-service-common/src/useIsJCSProjectType.tsx';
import { useProjectContext } from '@jira/platform__services-providers-project-context/src/index.tsx';
import type { UseResourceCustomContext } from '@jira/platform__routing-router-resource-with-custom-router-context/src/controllers/types.tsx';
import { useResourceWithCustomRouterContext } from '@jira/platform__routing-router-resource-with-custom-router-context/src/controllers/use-resource-with-custom-router-context/index.tsx';

export const useIsGetStartedPageEnabled = (
	customContext?: UseResourceCustomContext,
): [boolean, boolean] => {
	const { data, loading: projectContextLoading } = useProjectContext(customContext) || {};
	const { simplified: isSimplified = false, isProjectAdmin } = data || {};

	const { data: isGetStartedPageDisabled, loading: isGetStartedPageDisabledLoading } =
		useResourceWithCustomRouterContext(getStartedPropertyResource, customContext);

	const isJCS = isJCSProjectType(data?.projectType || '');

	const isDataLoading = projectContextLoading || isGetStartedPageDisabledLoading;

	return useMemo(
		() => [
			isDataLoading,
			!isDataLoading
				? Boolean(isJCS && isProjectAdmin && !isSimplified && !isGetStartedPageDisabled)
				: false,
		],
		[isDataLoading, isProjectAdmin, isSimplified, isGetStartedPageDisabled, isJCS],
	);
};
